import { memo } from 'react';
import styled from 'styled-components';
import { menu } from './Menu.tokens.js';
import { spacingsTemplate } from '@equinor/eds-utils';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { Divider } from '../Divider/Divider.js';
import { Typography } from '../Typography/Typography.js';

var Header = styled.div.attrs(function () {
  return {
    tabIndex: 0
  };
}).withConfig({
  displayName: "MenuSection__Header",
  componentId: "sc-gfcbvg-0"
})(["", " &:focus{outline:none;}"], spacingsTemplate(menu.entities.title.spacings));
var MenuSection = /*#__PURE__*/memo(function MenuSection(props) {
  var children = props.children,
    title = props.title,
    index = props.index;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [index !== 0 && /*#__PURE__*/jsx("div", {
      children: /*#__PURE__*/jsx(Divider, {
        variant: "small"
      })
    }), title && /*#__PURE__*/jsx(Header, {
      children: /*#__PURE__*/jsx(Typography, {
        group: "navigation",
        variant: "label",
        children: title
      })
    }), children]
  });
});

// MenuSection.displayName = 'EdsMenuSection'

export { MenuSection };
